const StorageKeys = {
  // auth
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  AUTHENTICATE: 'isAuthenticated',
  USER_AUTH: 'user_auth',
  USER_INFO: 'user_info',
  EMAIL_VERIFY: 'email_verify',

  //
  BRAND_INFO: 'brand_info',
  KITCHEN_CENTER_INFO: 'kitchen_center_info',

  // language
  I18_LANGUAGE: 'i18nextLng',

  // handles back page
  PATH_TO_BACK: 'pathToBack',

  // isEditing
  IS_EDIT_STORE: 'isEditingStore',
  IS_EDIT_STORE_PARTNER: 'isEditingStorePartner',
  IS_EDIT_CATEGORY: 'isEditingCategory',
  IS_EDIT_PRODUCT: 'isEditingProduct',
  IS_EDIT_PARTNER_PRODUCT: 'isEditingProduct',
  IS_EDIT_PARTNER: 'isEditingPartner',
  IS_EDIT_KITCHEN_CENTER: 'isEditingKitchenCenter',
  IS_EDIT_CASHIER: 'isEditingCashier',
  IS_EDIT_BANKING_ACCOUNT: 'isEditingBankingAccount',
  IS_EDIT_BRAND: 'isEditingBrand',
  IS_ADD_FORM_DETAIL: 'isAddFormDetail',
  IS_PRODUCT: 'isProduct',

  // pagination
  PAGE: 'page',
  ROW_PER_PAGE: 'rowsPerPage',

  // category
  CATEGORY_TYPE: 'categoryType',
  PRODUCT_TYPE: 'productType',
  PARTNER_PRODUCT: 'partnerProduct',

  //id
  STORE_ID: 'storeId',
  KC_PROVINCE_ID: 'KCProvinceId',
  KC_DISTRICT_ID: 'KCDistrictId',
  KC_WARD_ID: 'KCWardId',
  BRAND_PROVINCE_ID: 'BrandProvinceId',
  BRAND_DISTRICT_ID: 'BrandDistrictId',
  BRAND_WARD_ID: 'BrandWardId',
};

export { StorageKeys };
